import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/components/ui/button";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Check, Loader2 } from "lucide-react";
import { useState } from "react";
import { trpcClient } from "@/clients/trpcClient";
import { DOOR_TYPES, DOOR_WIDTHS, FEATURE_LEVELS, formatDistanceMeters, PARKING_PAYMENT, PARKING_SPACE_TYPES, SURFACE_TYPES } from "@/lib/utils/accessibilityLabels";
import { trpc } from "@/router";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BOOL_OPTIONS = [{
  value: "true",
  label: "Ja"
}, {
  value: "false",
  label: "Nej"
}];
export function EditableAssessment(t0) {
  const $ = _c(105);
  const {
    feature
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== feature.assessment?.data) {
    t1 = feature.assessment?.data ?? {};
    $[0] = feature.assessment?.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initial = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = trpc.features.types.queryOptions();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: t3
  } = useQuery(t2);
  let t4;
  if ($[3] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const featureTypes = t4;
  const currentTypeId = featureTypes.find(t => t.name === feature.featureTypeName)?.id;
  const [featureTypeId, setFeatureTypeId] = useState(null);
  if (featureTypeId === null && currentTypeId) {
    setFeatureTypeId(currentTypeId);
  }
  const t5 = initial.doorType ?? "unknown";
  const t6 = initial.estimatedDoorWidth ?? "unknown";
  const t7 = initial.hasDoorThreshold ?? false;
  const t8 = initial.hasSteps ?? false;
  const t9 = initial.stepCount ?? null;
  const t10 = initial.hasRamp ?? false;
  const t11 = initial.hasHandrails ?? false;
  const t12 = initial.hasAutomaticDoorOpener ?? false;
  const t13 = initial.surfaceType ?? "unknown";
  const t14 = initial.entranceLevel ?? "ground_level";
  const t15 = initial.hasContrastMarkings ?? false;
  const t16 = initial.hasIntercom ?? false;
  const t17 = initial.additionalNotes ?? "";
  const t18 = initial.parkingSpaceType ?? "unknown";
  const t19 = initial.hasWheelchairSign ?? false;
  const t20 = initial.hasGroundMarkings ?? false;
  const t21 = initial.hasKerbCut ?? false;
  const t22 = initial.isCovered ?? false;
  const t23 = initial.paymentType ?? "unknown";
  let t24;
  if ($[5] !== t10 || $[6] !== t11 || $[7] !== t12 || $[8] !== t13 || $[9] !== t14 || $[10] !== t15 || $[11] !== t16 || $[12] !== t17 || $[13] !== t18 || $[14] !== t19 || $[15] !== t20 || $[16] !== t21 || $[17] !== t22 || $[18] !== t23 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t24 = {
      doorType: t5,
      estimatedDoorWidth: t6,
      hasDoorThreshold: t7,
      hasSteps: t8,
      stepCount: t9,
      hasRamp: t10,
      hasHandrails: t11,
      hasAutomaticDoorOpener: t12,
      surfaceType: t13,
      entranceLevel: t14,
      hasContrastMarkings: t15,
      hasIntercom: t16,
      additionalNotes: t17,
      parkingSpaceType: t18,
      hasWheelchairSign: t19,
      hasGroundMarkings: t20,
      hasKerbCut: t21,
      isCovered: t22,
      paymentType: t23
    };
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
    $[11] = t16;
    $[12] = t17;
    $[13] = t18;
    $[14] = t19;
    $[15] = t20;
    $[16] = t21;
    $[17] = t22;
    $[18] = t23;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  const [form, setForm] = useState(t24);
  const isParking = feature.featureTypeName === "Parkering";
  let t25;
  if ($[25] !== feature.id || $[26] !== featureTypeId || $[27] !== form || $[28] !== initial) {
    t25 = () => trpcClient.features.updateAssessment.mutate({
      featureId: feature.id,
      featureTypeId: featureTypeId ?? undefined,
      data: {
        ...initial,
        ...form,
        confidence: 1,
        needsHumanReview: false
      }
    });
    $[25] = feature.id;
    $[26] = featureTypeId;
    $[27] = form;
    $[28] = initial;
    $[29] = t25;
  } else {
    t25 = $[29];
  }
  let t26;
  if ($[30] !== queryClient) {
    t26 = () => {
      queryClient.invalidateQueries({
        queryKey: [["features"]]
      });
    };
    $[30] = queryClient;
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  let t27;
  if ($[32] !== t25 || $[33] !== t26) {
    t27 = {
      mutationFn: t25,
      onSuccess: t26
    };
    $[32] = t25;
    $[33] = t26;
    $[34] = t27;
  } else {
    t27 = $[34];
  }
  const saveMutation = useMutation(t27);
  let t28;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = (key, value) => setForm(p => ({
      ...p,
      [key]: value
    }));
    $[35] = t28;
  } else {
    t28 = $[35];
  }
  const set = t28;
  let t29;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = /*#__PURE__*/_jsx("p", {
      className: "text-xs font-medium uppercase tracking-wider text-gray-400",
      children: "Bed\xF6mning (redigerbar)"
    });
    $[36] = t29;
  } else {
    t29 = $[36];
  }
  let t30;
  if ($[37] !== feature.distanceMeters || $[38] !== form.doorType || $[39] !== form.entranceLevel || $[40] !== form.estimatedDoorWidth || $[41] !== form.hasAutomaticDoorOpener || $[42] !== form.hasContrastMarkings || $[43] !== form.hasDoorThreshold || $[44] !== form.hasGroundMarkings || $[45] !== form.hasHandrails || $[46] !== form.hasIntercom || $[47] !== form.hasKerbCut || $[48] !== form.hasRamp || $[49] !== form.hasSteps || $[50] !== form.hasWheelchairSign || $[51] !== form.isCovered || $[52] !== form.parkingSpaceType || $[53] !== form.paymentType || $[54] !== form.stepCount || $[55] !== form.surfaceType || $[56] !== isParking) {
    t30 = isParking ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Field, {
        label: "Typ av ruta",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: form.parkingSpaceType,
          onChange: v => set("parkingSpaceType", v),
          options: Object.entries(PARKING_SPACE_TYPES).map(_temp)
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Avst\xE5nd",
        children: /*#__PURE__*/_jsx("span", {
          className: "text-xs font-medium text-gray-900",
          children: formatDistanceMeters(feature.distanceMeters)
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Skylt",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasWheelchairSign),
          onChange: v_1 => set("hasWheelchairSign", v_1 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Markm\xE5lning",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasGroundMarkings),
          onChange: v_2 => set("hasGroundMarkings", v_2 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Neds\xE4nkt kant",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasKerbCut),
          onChange: v_3 => set("hasKerbCut", v_3 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Tak \xF6ver",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.isCovered),
          onChange: v_4 => set("isCovered", v_4 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Avgift",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: form.paymentType,
          onChange: v_5 => set("paymentType", v_5),
          options: Object.entries(PARKING_PAYMENT).map(_temp2)
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Underlag",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: form.surfaceType,
          onChange: v_7 => set("surfaceType", v_7),
          options: Object.entries(SURFACE_TYPES).map(_temp3)
        })
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Field, {
        label: "D\xF6rtyp",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: form.doorType,
          onChange: v_9 => set("doorType", v_9),
          options: Object.entries(DOOR_TYPES).map(_temp4)
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "D\xF6rrbredd",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: form.estimatedDoorWidth,
          onChange: v_11 => set("estimatedDoorWidth", v_11),
          options: Object.entries(DOOR_WIDTHS).map(_temp5)
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Markyta",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: form.surfaceType,
          onChange: v_13 => set("surfaceType", v_13),
          options: Object.entries(SURFACE_TYPES).map(_temp6)
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Niv\xE5",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: form.entranceLevel,
          onChange: v_15 => set("entranceLevel", v_15),
          options: Object.entries(FEATURE_LEVELS).map(_temp7)
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Tr\xF6skel",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasDoorThreshold),
          onChange: v_17 => set("hasDoorThreshold", v_17 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Trappsteg",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasSteps),
          onChange: v_18 => set("hasSteps", v_18 === "true"),
          options: BOOL_OPTIONS
        })
      }), form.hasSteps && /*#__PURE__*/_jsx(Field, {
        label: "Antal steg",
        children: /*#__PURE__*/_jsx("input", {
          type: "number",
          min: 0,
          value: form.stepCount ?? 0,
          onChange: e => set("stepCount", parseInt(e.target.value) || null),
          className: "h-7 w-20 rounded border px-2 text-xs"
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Ramp",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasRamp),
          onChange: v_19 => set("hasRamp", v_19 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Handledare",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasHandrails),
          onChange: v_20 => set("hasHandrails", v_20 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Auto d\xF6rr\xF6ppnare",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasAutomaticDoorOpener),
          onChange: v_21 => set("hasAutomaticDoorOpener", v_21 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Kontrastmarkeringar",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasContrastMarkings),
          onChange: v_22 => set("hasContrastMarkings", v_22 === "true"),
          options: BOOL_OPTIONS
        })
      }), /*#__PURE__*/_jsx(Field, {
        label: "Porttelefon",
        children: /*#__PURE__*/_jsx(MiniSelect, {
          value: String(form.hasIntercom),
          onChange: v_23 => set("hasIntercom", v_23 === "true"),
          options: BOOL_OPTIONS
        })
      })]
    });
    $[37] = feature.distanceMeters;
    $[38] = form.doorType;
    $[39] = form.entranceLevel;
    $[40] = form.estimatedDoorWidth;
    $[41] = form.hasAutomaticDoorOpener;
    $[42] = form.hasContrastMarkings;
    $[43] = form.hasDoorThreshold;
    $[44] = form.hasGroundMarkings;
    $[45] = form.hasHandrails;
    $[46] = form.hasIntercom;
    $[47] = form.hasKerbCut;
    $[48] = form.hasRamp;
    $[49] = form.hasSteps;
    $[50] = form.hasWheelchairSign;
    $[51] = form.isCovered;
    $[52] = form.parkingSpaceType;
    $[53] = form.paymentType;
    $[54] = form.stepCount;
    $[55] = form.surfaceType;
    $[56] = isParking;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = /*#__PURE__*/_jsx("label", {
      className: "text-xs text-gray-500",
      children: "Anteckningar"
    });
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = e_0 => set("additionalNotes", e_0.target.value);
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== form.additionalNotes) {
    t33 = /*#__PURE__*/_jsxs("div", {
      className: "pt-1",
      children: [t31, /*#__PURE__*/_jsx("textarea", {
        value: form.additionalNotes,
        onChange: t32,
        className: "mt-1 h-16 w-full resize-none rounded border px-2 py-1 text-xs"
      })]
    });
    $[60] = form.additionalNotes;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== saveMutation) {
    t34 = () => saveMutation.mutate();
    $[62] = saveMutation;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] !== saveMutation.isPending) {
    t35 = saveMutation.isPending ? /*#__PURE__*/_jsx(Loader2, {
      className: "h-3.5 w-3.5 animate-spin"
    }) : /*#__PURE__*/_jsx(Check, {
      className: "h-3.5 w-3.5"
    });
    $[64] = saveMutation.isPending;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  let t36;
  if ($[66] !== saveMutation.isPending || $[67] !== t34 || $[68] !== t35) {
    t36 = /*#__PURE__*/_jsxs(Button, {
      size: "sm",
      onClick: t34,
      disabled: saveMutation.isPending,
      className: "gap-1.5 bg-brand hover:bg-brand/90",
      children: [t35, "Spara \xE4ndringar"]
    });
    $[66] = saveMutation.isPending;
    $[67] = t34;
    $[68] = t35;
    $[69] = t36;
  } else {
    t36 = $[69];
  }
  let t37;
  if ($[70] !== saveMutation.isSuccess) {
    t37 = saveMutation.isSuccess && /*#__PURE__*/_jsx("span", {
      className: "ml-2 text-xs text-green-600",
      children: "Sparat!"
    });
    $[70] = saveMutation.isSuccess;
    $[71] = t37;
  } else {
    t37 = $[71];
  }
  let t38;
  if ($[72] !== t30 || $[73] !== t33 || $[74] !== t36 || $[75] !== t37) {
    t38 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t29, t30, t33, t36, t37]
    });
    $[72] = t30;
    $[73] = t33;
    $[74] = t36;
    $[75] = t37;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  let t39;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = /*#__PURE__*/_jsx("p", {
      className: "mb-2 text-xs font-medium uppercase tracking-wider text-gray-400",
      children: "Inskickad information"
    });
    $[77] = t39;
  } else {
    t39 = $[77];
  }
  const t40 = String(feature.id);
  let t41;
  if ($[78] !== t40) {
    t41 = /*#__PURE__*/_jsx(Row, {
      label: "ID",
      value: t40
    });
    $[78] = t40;
    $[79] = t41;
  } else {
    t41 = $[79];
  }
  const t42 = String(featureTypeId ?? "");
  let t43;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = v_24 => setFeatureTypeId(parseInt(v_24));
    $[80] = t43;
  } else {
    t43 = $[80];
  }
  let t44;
  if ($[81] !== featureTypes) {
    t44 = featureTypes.map(_temp8);
    $[81] = featureTypes;
    $[82] = t44;
  } else {
    t44 = $[82];
  }
  let t45;
  if ($[83] !== t42 || $[84] !== t44) {
    t45 = /*#__PURE__*/_jsx(Field, {
      label: "Typ",
      children: /*#__PURE__*/_jsx(MiniSelect, {
        value: t42,
        onChange: t43,
        options: t44
      })
    });
    $[83] = t42;
    $[84] = t44;
    $[85] = t45;
  } else {
    t45 = $[85];
  }
  const t46 = feature.creator?.name ?? "Ok\xE4nd";
  let t47;
  if ($[86] !== t46) {
    t47 = /*#__PURE__*/_jsx(Row, {
      label: "Av",
      value: t46
    });
    $[86] = t46;
    $[87] = t47;
  } else {
    t47 = $[87];
  }
  let t48;
  if ($[88] !== feature.createdAt) {
    t48 = new Date(feature.createdAt).toLocaleString("sv-SE");
    $[88] = feature.createdAt;
    $[89] = t48;
  } else {
    t48 = $[89];
  }
  let t49;
  if ($[90] !== t48) {
    t49 = /*#__PURE__*/_jsx(Row, {
      label: "Datum",
      value: t48
    });
    $[90] = t48;
    $[91] = t49;
  } else {
    t49 = $[91];
  }
  let t50;
  if ($[92] !== t41 || $[93] !== t45 || $[94] !== t47 || $[95] !== t49) {
    t50 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-1.5 text-sm",
      children: [t41, t45, t47, t49]
    });
    $[92] = t41;
    $[93] = t45;
    $[94] = t47;
    $[95] = t49;
    $[96] = t50;
  } else {
    t50 = $[96];
  }
  let t51;
  if ($[97] !== feature.media) {
    t51 = feature.media?.url && /*#__PURE__*/_jsx("a", {
      href: feature.media.url,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "mt-2 inline-block text-xs text-brand hover:underline",
      children: "\xD6ppna bild i nytt f\xF6nster \u2192"
    });
    $[97] = feature.media;
    $[98] = t51;
  } else {
    t51 = $[98];
  }
  let t52;
  if ($[99] !== t50 || $[100] !== t51) {
    t52 = /*#__PURE__*/_jsxs("div", {
      children: [t39, t50, t51]
    });
    $[99] = t50;
    $[100] = t51;
    $[101] = t52;
  } else {
    t52 = $[101];
  }
  let t53;
  if ($[102] !== t38 || $[103] !== t52) {
    t53 = /*#__PURE__*/_jsx("div", {
      className: "border-t bg-gray-50 px-4 py-3",
      children: /*#__PURE__*/_jsxs("div", {
        className: "grid gap-3 md:grid-cols-2",
        children: [t38, t52]
      })
    });
    $[102] = t38;
    $[103] = t52;
    $[104] = t53;
  } else {
    t53 = $[104];
  }
  return t53;
}

// ─── Shared form primitives ─────────────────────────────────────────────────
function _temp8(t_0) {
  return {
    value: String(t_0.id),
    label: t_0.name
  };
}
function _temp7(t0) {
  const [k_5, v_16] = t0;
  return {
    value: k_5,
    label: v_16
  };
}
function _temp6(t0) {
  const [k_4, v_14] = t0;
  return {
    value: k_4,
    label: v_14
  };
}
function _temp5(t0) {
  const [k_3, v_12] = t0;
  return {
    value: k_3,
    label: v_12
  };
}
function _temp4(t0) {
  const [k_2, v_10] = t0;
  return {
    value: k_2,
    label: v_10
  };
}
function _temp3(t0) {
  const [k_1, v_8] = t0;
  return {
    value: k_1,
    label: v_8
  };
}
function _temp2(t0) {
  const [k_0, v_6] = t0;
  return {
    value: k_0,
    label: v_6
  };
}
function _temp(t0) {
  const [k, v_0] = t0;
  return {
    value: k,
    label: v_0
  };
}
export function Field(t0) {
  const $ = _c(5);
  const {
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = /*#__PURE__*/_jsx("span", {
      className: "shrink-0 text-xs text-gray-500",
      children: label
    });
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = /*#__PURE__*/_jsxs("div", {
      className: "flex items-center justify-between gap-2",
      children: [t1, children]
    });
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function MiniSelect(t0) {
  const $ = _c(8);
  const {
    value,
    onChange,
    options
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = e => onChange(e.target.value);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== options) {
    t2 = options.map(_temp9);
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== value) {
    t3 = /*#__PURE__*/_jsx("select", {
      value: value,
      onChange: t1,
      className: "h-7 rounded border bg-white px-1.5 text-xs font-medium text-gray-900",
      children: t2
    });
    $[4] = t1;
    $[5] = t2;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp9(o) {
  return /*#__PURE__*/_jsx("option", {
    value: o.value,
    children: o.label
  }, o.value);
}
export function Row(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = /*#__PURE__*/_jsx("span", {
      className: "shrink-0 text-gray-500",
      children: label
    });
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = /*#__PURE__*/_jsx("span", {
      className: "text-right font-medium text-gray-900",
      children: value
    });
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = /*#__PURE__*/_jsxs("div", {
      className: "flex justify-between gap-2",
      children: [t1, t2]
    });
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}